import { Fragment } from 'react';
import { getIsClosed, getIsFiltered, getIsOpen, getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
// @ts-expect-error type not available yet
import ThreadDeleteButton from '../../thread-deletion/components/ThreadDeleteButton';
import { isBotConversationWithRecentMessages } from '../../reassignment/operators/isBotConversationWithRecentMessages';
// @ts-expect-error type not available yet
import ThreadRestoreButton from '../../thread-deletion/components/ThreadRestoreButton';
// @ts-expect-error type not available yet
import OpenThreadButton from './OpenThreadButton';
// @ts-expect-error type not available yet
import CloseConversationButton from './CloseConversationButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadPrimaryActions = ({
  isOpeningThread,
  threadDetails,
  disabled,
  openThread,
  closeThread,
  isClosingCurrentConversation,
  isGrrPanelOpen,
  openDeletePrompt,
  restoreThread
}) => {
  const shouldShowOpenButton = getIsClosed(threadDetails) && !isClosingCurrentConversation;
  const shoudlShowCloseButton = getIsOpen(threadDetails) || isClosingCurrentConversation;
  if (getIsSoftDeleted(threadDetails)) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ThreadDeleteButton, {
        onClick: openDeletePrompt,
        disabled: disabled
      }), /*#__PURE__*/_jsx(ThreadRestoreButton, {
        onClick: restoreThread,
        disabled: disabled
      })]
    });
  } else if (shouldShowOpenButton) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(OpenThreadButton, {
        onClick: openThread,
        isOpeningThread: isOpeningThread,
        disabled: disabled
      })
    });
  } else if (shoudlShowCloseButton) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(CloseConversationButton, {
        onClick: closeThread,
        isActiveBotConversation: isBotConversationWithRecentMessages(threadDetails),
        isClosingCurrentConversation: isClosingCurrentConversation,
        disabled: disabled || isGrrPanelOpen
      }), getIsFiltered(threadDetails) && /*#__PURE__*/_jsx(ThreadDeleteButton, {
        onClick: openDeletePrompt,
        disabled: disabled
      })]
    });
  }
  return null;
};
ThreadPrimaryActions.displayName = 'ThreadPrimaryActions';
export default ThreadPrimaryActions;